<template>
    <div>
        <Panel
            :title="$t('Auto Attendant Profiles')"
            :add-button="$store.hasRight('ADD_AUTO_ATTENDANTS') ? $t('Add') : ''"
            :delete-button="selected.length > 0"
            :help-text="$t('DESC_AUTO_ATTENDANTS')"
            @delete="handleDelete"
            @input="openForm(-1)"
        >
            <table id="autoattendants_table" class="cic-table">
                <thead>
                    <tr>
                        <th>{{ $t('Profile Name') }}</th>
                        <th>{{ $t('Profile Description') }}</th>
                        <th v-if="$store.hasRight('DELETE_AUTO_ATTENDANTS')" class="td-checkbox"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="profile in items" @click="(evt) => handleOpen(profile.profileId, evt)">
                        <td class="primary">
                            {{ profile.name }}
                        </td>
                        <td>{{ profile.description }}</td>
                        <td v-if="$store.hasRight('DELETE_AUTO_ATTENDANTS')">
                            <cic-checkbox
                                :value="selected.indexOf(profile.profileId) !== -1"
                                @click="handleSelected(profile.profileId)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </Panel>

        <EditAutoAttendant
            v-if="item !== null && !$store.showLoadingOverlay"
            :item="item"
            @blur="closePopup"
            @input="saveItem"
            @change="handleChange"
            @changeList="loadPrompts"
        />

        <div v-if="$store.showLoadingOverlay" class="cic-overlay"></div>
    </div>
</template>

<script>
    import Panel from '@/components/container/Panel';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import TableUtils from '@/mixins/TableUtils';
    import { deleteItems, load, post, save } from '@/utils/Http';
    import { loadPrompts, RouteType } from '@/utils/RouteCollectionUtils';
    import EditAutoAttendant from './EditAutoAttendant';
    import './styles/autoAttendants.scss';

    export default {
        name: 'AutoAttendants',
        components: {
            Panel,
            EditAutoAttendant,
            CicCheckbox,
        },
        mixins: [TableUtils],
        data() {
            return {
                item: null,
                items: [],
                selected: [],
            };
        },
        created() {
            this.$store.clearRouteData();
            this.loadTable();
        },
        methods: {
            handleDelete() {
                deleteItems('autoattendants/delete', { profileIds: this.selected }, () => {
                    this.loadTable();
                });
            },

            loadPrompts(mediaListId) {
                loadPrompts(mediaListId, post, this.$forceUpdate);
            },

            loadTable() {
                this.selected = [];
                load('autoattendants/get', {}, (response) => {
                    this.items = response.profiles;
                });
            },

            openForm(profileId) {
                const params = { profileId, services: this.$store.routeData.mediaLists ? '0' : '1' };
                load('autoattendant/get', params, (response) => {
                    this.item = response.profile;
                    if (response.mediaLists) {
                        this.$store.buildRouteStore({ ...response, autoAttendantProfiles: this.items });
                    }

                    this.item.routes
                        .filter(
                            (x) =>
                                x.route.type === RouteType.CustomService &&
                                this.$store.routeData.splitProfiles.some((y) => y.scriptId === x.route.scriptId),
                        )
                        .map((x) => (x.route.type = RouteType.PercentageSplit));

                    this.loadPrompts(this.item.mediaListId);
                });
            },

            saveItem() {
                if (this.item.name.trim() === '') {
                    alert(this.$t('Profile Name is a required field'));
                    return;
                }

                const params = { profileId: this.item.profileId, data: JSON.stringify(this.item) };
                save('autoattendant/update', params, () => {
                    this.loadTable();
                });
            },

            handleChange(field, value) {
                if (field === 'mediaListId') {
                    this.item = {
                        ...this.item,
                        mediaListId: value,
                        introPromptId: null,
                        noResponsePromptId: null,
                        invalidPromptId: null,
                    };
                    this.loadPrompts(value);
                } else {
                    this.updateFieldValue(field, value);
                }
            },
        },
    };
</script>
